import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LeadershipVision from "./sections/LeadershipVision";
import About from "./sections/About";
import ArtisanSanctuaries from "./sections/ArtisanSanctuaries";
import GlobalFitnessPartners from "./sections/GlobalFitnessPartners";
import TheBriefingRoom from "./sections/TheBriefingRoom";
import InformationFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LeadershipVision />
      <About />
      <ArtisanSanctuaries />
      <GlobalFitnessPartners />
      <TheBriefingRoom />
      <InformationFooter />
    </div>;
}